import { render, staticRenderFns } from "./Consumables.vue?vue&type=template&id=2b960e0f&scoped=true"
import script from "./Consumables.vue?vue&type=script&lang=js"
export * from "./Consumables.vue?vue&type=script&lang=js"
import style0 from "./Consumables.vue?vue&type=style&index=0&id=2b960e0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b960e0f",
  null
  
)

export default component.exports